<router-outlet *ngIf="userServiceStatus === 'loaded'; else notReady"></router-outlet>

<ng-template #notReady>
  <ng-container *ngIf="userServiceStatus === 'broken'; else loading">Something went wrong</ng-container>
  <ng-template #loading>Loading...</ng-template>
</ng-template>
